<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Class Teacher Remark">
        <v-card flat class="px-2">
          <form @submit.prevent="termListing">
            <v-row>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2"> Class<span class="error--text">*</span> </label>
                <v-autocomplete
                  class="my-0 py-1"
                  placeholder="--SELECT--"
                  name="classSelect"
                  required
                  v-model="selectedClassID"
                  v-on:change="changeSections(), termLists()"
                  item-value="id"
                  item-text="name"
                  :items="classes"
                  key="id"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Section
                </label>
                <v-autocomplete class="my-0 py-1" placeholder="--SELECT--" name="sectionSelect" v-model="selectedSectionID" item-value="id" :items="classWiseSections" key="id" item-text="name">
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">Select Term <span class="error--text">*</span></label>
                <v-autocomplete
                  class="my-0 py-1"
                  placeholder="--SELECT--"
                  required
                  v-model="term"
                  :items="terms"
                  key="id"
                  item-value="id"
                  :item-text="item => item.academicTerm.name + `(${item.fromDate}) ` + `/ (${item.toDate})`"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <span class="font-weight-medium body-2">Action</span>
                <div class="inside">
                  <v-btn elevation="1" type="submit" color="success"><v-icon left>mdi-text-box-check-outline</v-icon>Apply</v-btn>
                </div>
              </v-col>
            </v-row>
          </form>
        </v-card>
        <v-card-component v-if="termList.length > 0">
          <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-card-title>
              Total Records : {{ total }}
              <v-spacer></v-spacer>
            </v-card-title>
          </v-card-text>
          <v-divider class=" my-0 " />
          <v-data-table
            :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
            :items-per-page="10"
            :headers="headers"
            :items="termList"
          >
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
            <template v-slot:item.generalRemark="{ item }">
              {{ item.gradeTeacherRemark ? item.gradeTeacherRemark.generalRemark : '-' }}
            </template>
            <template v-slot:item.behavioralRemark="{ item }">
              {{ item.gradeTeacherRemark ? item.gradeTeacherRemark.behavioralRemark : '-' }}
            </template>
            <template v-slot:item.actions="{ item }">
              <span v-if="isWrite" class="d-flex justify-center">
                <v-btn outlined v-if="item.gradeTeacherRemark === null" @click="toggleEnquiryModal(item.id)" class="px-2 ml-1 ma-1" color="primary" min-width="0" small>
                  add Remark
                </v-btn>
                <v-btn outlined v-if="item.gradeTeacherRemark !== null" @click="editGrade(item.gradeTeacherRemark.id)" class="px-2 ml-1 ma-1" color="success" min-width="0" small>
                  edit Remark
                </v-btn>
              </span>
            </template>
          </v-data-table>
        </v-card-component>
      </material-card>
      <v-dialog persistent v-model="enableEnquiryModal" max-width="650">
        <form @submit.prevent="Save">
          <v-card>
            <v-toolbar dark color="darkblue">
              <v-toolbar-title> Add Remark</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="toggleEnquiryModal, clearAll()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field label="General Remarks" required v-model.trim="gReamark" maxlength="300" counter> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Behaviour Remarks" required v-model.trim="bReamark" maxlength="300" counter> </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-card-actions class="justify-end">
                    <v-btn color="success" type="submit">Save</v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </form>
      </v-dialog>
      <v-dialog persistent v-model="enableRemarkModal" max-width="650">
        <form @submit.prevent="EditSave">
          <v-card>
            <v-toolbar dark color="darkblue">
              <v-toolbar-title> Edit Remark</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="toggleRemarkModal, clearEditRemark()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field label="General Remarks" required v-model.trim="gReamark" maxlength="300" counter> </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Behaviour Remarks" required v-model.trim="bReamark" maxlength="300" counter> </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-card-actions class="justify-end">
                    <v-btn color="success" type="submit">Save</v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card-text>
            <v-spacer></v-spacer>
          </v-card>
        </form>
      </v-dialog>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import Utils from '@/utils'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  name: 'classTeacherRemark',
  components: { MaterialCard, VCardComponent },
  data () {
    return {
      isLoading: true,
      total: 0,
      termList: [],
      term: '',
      search: '',
      terms: [],
      franchiseeID: '',
      franchiseeArr: [],
      academicYearID: '',
      selectedStudent: '',
      gReamark: '',
      bReamark: '',
      academicYears: [],
      selectedClassID: '',
      academicTermDateMapid: '',
      selectedSectionID: '',
      enableEnquiryModal: false,
      enableRemarkModal: false,
      classID: '',
      classWiseSections: [],
      classes: [],
      isWrite: false,
      headers: [
        { text: 'Enrollment Code', value: 'studentEnrollment.enrollmentCode', sortable: true },
        { text: 'Student Name', value: 'studentEnrollment.studentName', sortable: true },
        { text: 'Class Teacher General Remarks', value: 'generalRemark', sortable: false },
        { text: 'Class Teacher behaviour Remarks', value: 'behavioralRemark', sortable: false },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false }
      ]
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    // await this.getClassList()
    // await this.getFranchiseeList()
    await this.getYear()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYearID: async function () {
      if (this.franchiseeID) {
        await this.getClassList()
      }
    },
    // Commented for list fetch
    selectedSectionID () {
      // this.termList = []
      // this.total = 0
    },
    term () {
      // this.termList = []
      // this.total = 0
    }
  },
  methods: {
    termListing: async function () {
      this.isLoading = true
      const { data } = await http.get(`${constants.API_URL}/api/grade-module/grade-teacher-remark`, {
        params: { franchiseeID: this.franchiseeID, academicYearID: this.academicYearID, classID: this.selectedClassID, sectionID: this.selectedSectionID, academicTermsDateID: this.term }
      })

      this.termList = data
      if (this.termList.length === 0) {
        this.$dialog.error({
          title: 'Error',
          text: 'No Data Found'
        })
      }
      this.total = this.termList.length
      this.isLoading = false
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }

        if (this.franchiseeID) {
          await this.getClassList()
        }
        this.selectedClassID = ''
        this.selectedSectionID = ''
        this.total = 0
        this.termList = []
        this.clearClass()
        this.inProgress = false
      }
    },
    termLists: async function () {
      this.term = ''
      this.terms = []
      this.termList = ''
      this.total = 0
      try {
        this.isLoading = true
        const Terms = await http.get(`${constants.API_URL}/api/grade-module/academic-terms/date/map`, {
          params: { franchiseeID: this.franchiseeID, academicYearID: this.academicYearID, classID: this.selectedClassID }
        })
        if (Terms.data.length === 0) {
          this.$dialog.message.warning('Academic Term Not Found With Selected Class , Academic Year And Franchisee', {
            position: 'top',
            timeout: 6000
          })
        } else {
          this.terms = Terms.data
          let x = this.terms.map(a => {
            a.fromDate = moment(a.fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
            return a
          })
          let y = this.terms.map(b => {
            b.toDate = moment(b.toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
            return b
          })
          this.terms = x
          this.terms = y
          this.isLoading = false
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getYear: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getClassList: async function () {
      try {
        this.classes = []
        let response = await http.get(`${constants.API_URL}/api/student/all-count?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&isAllValue=true`)
        const data = response.data
        this.classes = data

        this.sections = data.map(obj => {
          return {
            id: obj.id,
            sections: obj.studentSections
          }
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        this.errMsg(errorMessage)
      }
    },
    changeSections: async function () {
      let sectionarray = this.sections.find(obj => obj.id === this.selectedClassID)
      if (sectionarray) {
        this.classWiseSections = sectionarray.sections
      } else {
        this.classWiseSections = []
      }
    },
    Save: async function () {
      if (!this.gReamark) {
        this.errMsg('General remark cannot be empty!')
        return false
      }
      if (!this.bReamark) {
        this.errMsg('Behaviour remark cannot be empty!')
        return false
      }
      let formData = {
        franchiseeID: this.franchiseeID,
        classID: this.selectedClassID,
        academicTermsDateMapID: this.term,
        sectionID: this.selectedSectionID,
        studentAdmissionsID: this.selectedStudent,
        generalRemark: this.gReamark,
        behavioralRemark: this.bReamark
      }
      try {
        await http.post(`${constants.API_URL}/api/grade-module/grade-teacher-remark`, formData)
        this.clearAll()
        this.termListing()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    editGrade: async function (ID) {
      this.academicTermDateMapid = ID
      try {
        let { data } = await http.get(`${constants.API_URL}/api/grade-module/grade-teacher-remark/${this.academicTermDateMapid}`)
        this.gReamark = data[0].gradeTeacherRemark.generalRemark
        this.bReamark = data[0].gradeTeacherRemark.behavioralRemark
        this.toggleRemarkModal()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        this.errMsg(errorMessage)
      }
    },
    EditSave: async function () {
      this.hasClicked = true
      let remarkData = {
        generalRemark: this.gReamark,
        behavioralRemark: this.bReamark
      }
      try {
        await http.put(`${constants.API_URL}/api/grade-module/grade-teacher-remark/${this.academicTermDateMapid}`, remarkData)
        this.clearEditRemark()
        this.termListing()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Data', errorMessage)
      }
    },
    toggleEnquiryModal: function (id) {
      this.selectedStudent = id
      this.enableEnquiryModal = !this.enableEnquiryModal
    },
    toggleRemarkModal: function () {
      this.enableRemarkModal = !this.enableRemarkModal
    },
    clearAll: function () {
      this.gReamark = ''
      this.bReamark = ''
      this.selectedStudent = ''
      this.enableEnquiryModal = !this.enableEnquiryModal
    },
    clearEditRemark: function () {
      this.gReamark = ''
      this.bReamark = ''
      this.academicTermDateMapid = ''
      this.enableRemarkModal = !this.enableRemarkModal
    },
    clearClass: function () {
      this.terms = []
      this.term = ''
      this.termList = ''
      this.selectedClassID = ''
      this.selectedSectionID = ''
    },
    errMsg (msg) {
      return this.$dialog.error({
        title: 'Error',
        text: msg
      })
    }
  }
}
</script>
